import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskProformaProjectFormsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-proforma-project-forms',
	path: '/jira/servicedesk/projects/:projectKey/settings/forms',
	exact: true,
};
